export default "__VITE_ASSET__Uto8a0vo__"